import axiosInstance from '../axios/axiosInstance';
import { LearningAsset, Page } from '../model/response';
import {
  LearningAssetCreateRequest,
  LearningAssetTreeRequest,
  LearningAssetUpdateRequest,
  TableParams,
} from '../model/request';

export const getPageLearningAsset = async (
  tableParams: TableParams,
  keyword: string,
  tagIds: string[] = [],
  categoryIds: string[] = [],
  learningBookIds: string[] = [],
) => {
  const params = {
    size: tableParams.pagination ? tableParams.pagination.pageSize : 10,
    page: tableParams.pagination && tableParams.pagination.current ? tableParams.pagination.current - 1 : 0,
    keyword,
    tagIds,
    categoryIds,
    learningBookIds,
    fromCMS: true,
  };
  const { data } = await axiosInstance.get<Page<LearningAsset>>('learning-assets/page', {
    params: params,
    paramsSerializer: {
      indexes: null,
    },
  });
  return data;
};

export const findLearningAssetById = async (id: string) => {
  const { data } = await axiosInstance.get<LearningAsset>('learning-assets/' + id);
  return data;
};

export const findAllByLearningBookId = async (learningBookId: string): Promise<LearningAsset[]> => {
  const { data } = await axiosInstance.get<LearningAsset[]>('learning-assets/find-all-by-learning-book-id', {
    params: { learningBookId },
  });
  return data;
};

export const updateLearningAsset = async (
  id: string,
  learningAssetRequest: LearningAssetUpdateRequest,
): Promise<void> => {
  await axiosInstance.put<string>(`learning-assets/${id}`, createFormData(learningAssetRequest), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateLearningAssetFromTree = async (
  id: string,
  learningAssetRequest: LearningAssetTreeRequest,
): Promise<void> => {
  await axiosInstance.put<string>(`learning-assets/${id}/update-from-tree`, createFormData(learningAssetRequest), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const createLearningAsset = async (learningAssetRequest: LearningAssetCreateRequest): Promise<string> => {
  const { data } = await axiosInstance.post<string>(`learning-assets`, createFormData(learningAssetRequest), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const deleteLearningAsset = async (id: string) => {
  await axiosInstance.delete<void>('learning-assets/' + id);
};

const createFormData = (
  learningAssetRequest: LearningAssetCreateRequest | LearningAssetUpdateRequest | LearningAssetTreeRequest,
) => {
  const formData = new FormData();
  formData.set('name', learningAssetRequest.name);
  formData.set('description', learningAssetRequest.description);
  if ((learningAssetRequest as any).file) {
    formData.set('file', (learningAssetRequest as any).file);
  }
  if ((learningAssetRequest as any).originFilename) {
    formData.set('originFilename', (learningAssetRequest as any).originFilename);
  }
  if ((learningAssetRequest as any).thumbnail) {
    formData.set('thumbnail', (learningAssetRequest as any).thumbnail);
  }
  if ((learningAssetRequest as any).learningBook) {
    formData.set('learningBook', (learningAssetRequest as any).learningBook.id);
  }
  if (learningAssetRequest.lesson) {
    formData.set('lesson', learningAssetRequest.lesson);
  }
  if (learningAssetRequest.chapter) {
    formData.set('chapter', learningAssetRequest.chapter);
  }
  if (learningAssetRequest.status) {
    formData.set('status', learningAssetRequest.status);
  }
  formData.set('tags', learningAssetRequest.tags.map((tag) => tag.id).join(','));
  formData.set('categories', learningAssetRequest.categories.map((category) => category.id).join(','));
  return formData;
};
